import {
  createStyles,
  IconButton,
  makeStyles,
  Theme
} from "@material-ui/core";
import clsx from 'clsx';
import React from "react";
import { ArrowTooltip } from "./tooltips";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    disabled: {
      opacity: 0.3
    }
  })
);

export const EnhancedIconButton = (props) => {
  const classes = useStyles();
  const {title, visible, onClick, disabled, children} = props;

  const isVisible = visible !== undefined ? visible : true;
  const tooltipText = disabled ? `${title} (Disabled)` : title;

  const createMarkup = () => {
    return tooltipText ?
      (<div dangerouslySetInnerHTML={{__html: tooltipText}}/>) :
      "";
  };

  return (
    <React.Fragment>
      {isVisible && (<ArrowTooltip title={createMarkup()}>
        <IconButton
          size="small"
          onClick={disabled ? undefined :onClick}
          className={clsx("", {
            [classes.disabled]: disabled
          })}
        >
          {children}
        </IconButton>
      </ArrowTooltip>)}
    </React.Fragment>
  );
};
